import React from 'react';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import { constants, removeFromSessionStorage, saveToSessionStorage } from '@dc/ui-library';
import Checkbox from '@dc/ui-library/src/molecules/Checkbox/Checkbox';
import Tooltip from '@dc/ui-library/src/molecules/Tooltip/Tooltip';
import { connect } from 'react-redux';
import { addProduct, removeProduct } from '../../../../appState/ducks/listingPageComparison';

const ADD_PRODUCT = 'ADD_PRODUCT';
const REMOVE_PRODUCT = 'REMOVE_PRODUCT';
const Analytics = require('../../../../analytics');

class CompareCheckbox extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showTooltip: false
    };

    this.handleClick = this.handleClick.bind(this);
    this.dispatchClickCompareButton = this.dispatchClickCompareButton.bind(this);
  }

  getCheckboxLabel(changeLabel) {
    if (changeLabel && this.props.products.length > 0) {
      return ReactDOMServer.renderToStaticMarkup(
        <button>Compare ({this.props.products.length} of 4)</button>
      );
    }

    return ReactDOMServer.renderToStaticMarkup(
      <span>Compare (up to 4 items)</span>
    );
  }

  getCheckboxState() {
    // disable all checkboxes which were not selected
    let disabled = false;
    let checked = false;

    const productSelected = this.props.products.find(
      product => product.id === this.props.product.id
    );

    if (productSelected) {
      checked = true;
    } else if (this.props.products.length === 4) {
      // Product is not selected and there are already 4 products selected in redux store.
      // Checkbox must be disabled. It's allowed to select max 4 products to compare.
      disabled = true;
    }

    return { checked, disabled };
  }

  dispatchClickCompareButton() {
    const checkedProducts = window.appState.getState().listingPage.comparison.products;
    const fupids = [];
    Object.keys(checkedProducts).forEach((key) => {
      const products = checkedProducts[key];
      products.forEach((product) => {
        fupids.push(product.productID);
      });
    });
    Analytics.dispatchClickCompareButton(fupids);

    // saves url pathname of current listing page to session storage
    // which is used in backButton on compare page
    saveToSessionStorage(
      constants.SESSION_STORAGE_COMPARISON_LAST_PAGE_PATH,
      window.location.pathname
    );
    removeFromSessionStorage(
      constants.SESSION_STORAGE_COMPARISON_BACK_LINK_LABEL
    );
  }

  handleClick(e) {
    e.preventDefault();
    let action = ADD_PRODUCT;
    const { disabled } = this.getCheckboxState();
    const {
      containerFormEl, product, products, productSegmentId
    } = this.props;
    let err = false;
    let status = 'unchecked';

    let errorMessage = '';

    // If there is selected at least 1 product to compare and user clicked on label of checkbox,
    // form needs to be submitted and user is redirected to cmpare page.
    if (products.length > 0 &&
      e.target.matches('.dc-checkbox-wrapper .dc-checkbox-label button')) {
      // dispatch analytics also when user clicks on link of checked checkbox
      this.dispatchClickCompareButton();
      return containerFormEl && containerFormEl.submit();
    }

    products.forEach((selectedProduct) => {
      if (selectedProduct.id === product.id) {
        // If selectedProduct is already in store, then selectedProduct needs to be removed
        // from store after click and in this case dispatch analytics
        action = REMOVE_PRODUCT;
      } else if (disabled && (products.length >= 4)) {
        // If there are already 4 products in store and user wants to add another one to compare,
        // then tooltip with message is shown to user.
        err = true;
        this.setState({ showTooltip: true }, () =>
          setTimeout(() => {
            this.setState({ showTooltip: false });
          }, 3000));
      }
    });

    if (err === true) {
      errorMessage = 'User Error Message';
      status = 'error';
    } else {
      errorMessage = null;
    }

    if (action === ADD_PRODUCT && products.length < 4) {
      this.props.addProduct({ product, productSegmentId });
      status = 'checked';
    } else if (action === REMOVE_PRODUCT) {
      this.props.removeProduct({ product, productSegmentId });
      status = 'unchecked';
    }

    Analytics.dispatchComparisonCheckClick(product.id, status, errorMessage);

    return undefined;
  }

  render() {
    const { checked, disabled } = this.getCheckboxState();
    const labelText = this.getCheckboxLabel(checked);

    return (
      <div>
        <div className="compare-checkbox" onClick={e => this.handleClick(e)}>
          <Checkbox
            small
            label={labelText}
            disabled={disabled}
            checked={checked}
          />
        </div>
        <div className="compare-checkbox-tooltip">
          {this.state.showTooltip
          ? (
            <Tooltip
              arrow={this.props.tooltipArrowDirection}
              textAlign="center"
              radius
              style="compact"
            >
              {this.props.tooltipTextTranslate}
            </Tooltip>) : <noscript />}
        </div>
      </div>
    );
  }
}

CompareCheckbox.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.string.isRequired
  }).isRequired,
  productSegmentId: PropTypes.number.isRequired,
  addProduct: PropTypes.func,
  containerFormEl: PropTypes.instanceOf(HTMLFormElement),
  products: PropTypes.arrayOf(PropTypes.object),
  removeProduct: PropTypes.func,
  tooltipArrowDirection: PropTypes.oneOf([
    'top',
    'right',
    'bottom',
    'left'
  ]),
  tooltipTextTranslate: PropTypes.string.isRequired
};

CompareCheckbox.defaultProps = {
  addProduct: () => {},
  containerFormEl: null,
  products: [],
  removeProduct: () => {},
  tooltipArrowDirection: 'top'
};

function mapStateToProps(state) {
  const currentPageSegmentId = state.listingPage.pageSetup.category.segmentId;
  return {
    productSegmentId: currentPageSegmentId,
    products: state.listingPage.comparison.products[currentPageSegmentId] || []
  };
}

export default connect(mapStateToProps, { addProduct, removeProduct })(CompareCheckbox);
